module.exports = __webpack_public_path__ + "img/tech_11.9ef9a831.jpg";